<div class="equip-form-page">
  <div class="equip-form-card">
    <h2 class="equip-form-title">Add Equipment</h2>

    <form (ngSubmit)="saveEquipment()" #addForm="ngForm">

      <!-- Image -->
      <div class="form-row">
        <label>Photo</label>
        <div class="image-uploader">
          <div class="image-preview" [class.empty]="!newEquipment.imageUrl">
            <img *ngIf="newEquipment.imageUrl" [src]="newEquipment.imageUrl" alt="Equipment photo">
            <mat-icon *ngIf="!newEquipment.imageUrl">construction</mat-icon>
          </div>
          <div class="image-actions">
            <label class="upload-btn">
              <mat-icon>upload</mat-icon> {{ newEquipment.imageUrl ? 'Replace Photo' : 'Upload Photo' }}
              <input type="file" accept="image/*" (change)="onImageSelected($event)" hidden>
            </label>
            <button type="button" class="remove-btn" *ngIf="newEquipment.imageUrl" (click)="removeImage()">
              <mat-icon>delete</mat-icon> Remove
            </button>
          </div>
          <p class="image-error" *ngIf="imageError">{{ imageError }}</p>
        </div>
      </div>

      <!-- Name -->
      <div class="form-row">
        <label for="name">Name</label>
        <input id="name" type="text" [(ngModel)]="newEquipment.name" name="name" required />
      </div>

      <!-- Description -->
      <div class="form-row">
        <label for="description">Description</label>
        <textarea id="description" [(ngModel)]="newEquipment.description" name="description" rows="3"></textarea>
      </div>

      <div class="form-two-col">
        <!-- Quantity -->
        <div class="form-row">
          <label for="quantity">Quantity in Stock</label>
          <input id="quantity" type="number" min="0" [(ngModel)]="newEquipment.quantity" name="quantity" />
        </div>

        <!-- Daily Rate -->
        <div class="form-row">
          <label for="dailyRate">Daily Rental Rate</label>
          <div class="price-input">
            <span class="price-prefix">$</span>
            <input id="dailyRate" type="number" min="0" step="0.01" [(ngModel)]="newEquipment.dailyRate" name="dailyRate" />
            <span class="price-suffix">/ day</span>
          </div>
        </div>
      </div>

      <!-- Manufacturer -->
      <div class="form-row">
        <label for="manufacturer">Manufacturer</label>
        <select id="manufacturer" name="manufacturer"
                [ngModel]="newEquipment.manufacturer?.id"
                (ngModelChange)="onManufacturerChange($event)">
          <option [ngValue]="0">— Select manufacturer —</option>
          <option *ngFor="let m of manufacturers" [ngValue]="m.id">{{ m.name }}</option>
        </select>
      </div>

      <div class="form-actions">
        <button type="button" class="btn-secondary" (click)="cancel()">Cancel</button>
        <button type="submit" class="btn-primary" [disabled]="isSaving || addForm.invalid">
          {{ isSaving ? 'Saving…' : 'Add Equipment' }}
        </button>
      </div>
    </form>
  </div>
</div>
